module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', [_vm._v("Document")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-8"
  }, [_c('Radiobutton', {
    attrs: {
      "id": "passport",
      "value": "Passport"
    },
    model: {
      value: (_vm.document),
      callback: function($$v) {
        _vm.document = $$v
      },
      expression: "document"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "passport"
    }
  }, [_vm._v("Passport")]), _vm._v(" "), _c('Radiobutton', {
    attrs: {
      "id": "citizenship",
      "value": "Citizenship"
    },
    model: {
      value: (_vm.document),
      callback: function($$v) {
        _vm.document = $$v
      },
      expression: "document"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "citizenship"
    }
  }, [_vm._v("Citizenship")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "number"
    }
  }, [_vm._v("Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "number"
    },
    model: {
      value: (_vm.number),
      callback: function($$v) {
        _vm.number = $$v
      },
      expression: "number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "issuedDate"
    }
  }, [_vm._v("Issued Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.issuedDate),
      callback: function($$v) {
        _vm.issuedDate = $$v
      },
      expression: "issuedDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "issuedDate"
    },
    model: {
      value: (_vm.issuedDate),
      callback: function($$v) {
        _vm.issuedDate = $$v
      },
      expression: "issuedDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "expiredDate"
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "expiredDate"
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "eligible"
    }
  }, [_vm._v("Eligible Status")]), _vm._v(" "), _c('input-text', {
    attrs: {
      "id": "eligible"
    },
    model: {
      value: (_vm.eligibleStatus),
      callback: function($$v) {
        _vm.eligibleStatus = $$v
      },
      expression: "eligibleStatus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "issuedBy"
    }
  }, [_vm._v("Issued By")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "optionLabel": "name",
      "placeholder": "--Select--",
      "id": "issuedBy"
    },
    model: {
      value: (_vm.issuedBy),
      callback: function($$v) {
        _vm.issuedBy = $$v
      },
      expression: "issuedBy"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "eligibleReviewDate"
    }
  }, [_vm._v("Eligible Review Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.eligibleReviewDate),
      callback: function($$v) {
        _vm.eligibleReviewDate = $$v
      },
      expression: "eligibleReviewDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "eligibleReviewDate"
    },
    model: {
      value: (_vm.eligibleReviewDate),
      callback: function($$v) {
        _vm.eligibleReviewDate = $$v
      },
      expression: "eligibleReviewDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "comment"
    }
  }, [_vm._v("Comment")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "id": "comment",
      "rows": "5",
      "cols": "30"
    },
    model: {
      value: (_vm.reason),
      callback: function($$v) {
        _vm.reason = $$v
      },
      expression: "reason"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-5 p-mb-5"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Save",
      "icon": "pi pi-save"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f35502d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/immigration.vue
// module id = 2172
// module chunks = 0